import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NavigationConstant } from '../../constant/navigation.constant';

@Component({
  selector: 'app-step',
  templateUrl: './step.component.html',
  styleUrls: ['./step.component.css']
})
export class StepComponent implements OnInit {
  class: string;
  icon: string;

  constructor(
    // private activatedRoute: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit() {
    // if(this.activatedRoute.snapshot.url[0].path === "inquiry"){
    //   this.class = "alert alert-dark";
    //   this.icon = "fa fa-dot-circle";
    // } else{
    //   this.class = "alert alert-success";
    //   this.icon = "fa fa-clock";
    // }
  }

  goHome() {
    this.router.navigate([NavigationConstant.HOME]);
  }

}
